import { render, staticRenderFns } from "./ManagerMenu.vue?vue&type=template&id=4b6849b6&scoped=true"
import script from "./ManagerMenu.vue?vue&type=script&lang=js"
export * from "./ManagerMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6849b6",
  null
  
)

export default component.exports